import {
	DEFAULT_AGENT_NAMED_ID,
	DEFAULT_AGENT_UUID,
} from '@atlassian/conversation-assistant-utils/default-agent';

import { type ChatStoreContainerProps } from '../types';

type MinionVerificationItem = {
	alias: string;
	minionId: string;
};

// The General Agent runtime UUID (DEFAULT_AGENT_UUID) doubles as the Solution Architect Agent
// runtime identity, which is currently the only agent with minion verification implemented. Minion
// verification analytics are gated to this identity (and the default named-id) for that reason.
const possible_agents = [DEFAULT_AGENT_UUID, DEFAULT_AGENT_NAMED_ID];

const MINION_VERIFICATION_ITEMS: MinionVerificationItem[] = [
	{
		alias: 'design-solution',
		minionId: 'SolutionArchitectMinion',
	},
	{
		alias: 'rovo-agent-builder',
		minionId: 'AgentBuilderMinion',
	},
	{
		alias: 'build-agent',
		minionId: 'AgentBuilderMinion',
	},
	{
		alias: 'build-automation',
		minionId: 'AutomationWorkflowBuilderMinion',
	},
];

type MinionVerificationAnalyticsProps = {
	minionAlias?: string;
	agentId?: string;
	minionsOutput: { minion_id: string }[];
	sendAnalyticsEvent: ChatStoreContainerProps['sendAnalyticsEvent'];
};

export const minionVerificationAnalytics = ({
	minionAlias,
	agentId,
	minionsOutput,
	sendAnalyticsEvent,
}: MinionVerificationAnalyticsProps): void => {
	if (!minionAlias) {
		return;
	}
	if (agentId && !possible_agents.includes(agentId)) {
		return;
	}

	MINION_VERIFICATION_ITEMS.forEach(({ alias, minionId }) => {
		if (alias !== minionAlias) {
			return;
		}

		const hasAliasMatch = minionsOutput.some((output) => output.minion_id === minionId);

		sendAnalyticsEvent({
			eventType: 'track',
			action: hasAliasMatch ? 'matched' : 'mismatched',
			actionSubject: 'aiMateMinionVerification',
			attributes: {
				name: minionId,
			},
		});
	});
};
